
document.addEventListener("DOMContentLoaded", () => {
  
  // dynamic day functionality on product page text
  document?.querySelectorAll(".icon-label-container.dynamic-days .icon-label > span")?.forEach(elem => {
    // extract from text eg "... {days:4} ..." will be 4
    const days = parseInt(elem.innerHTML.split("{days:")?.[1]?.split("}")?.[0])

    if (!isNaN(days)) {
      const today = new Date()
      const date = new Date(today.setDate(today.getDate() + days))
      const formatted = formatDate(date)
      const html = elem.innerHTML.replace(/\{(.*?)\}/, formatted)

      elem.innerHTML = html
      elem.closest(".icon-label-container")?.classList.add("loaded")
    } else {
      elem.closest(".icon-label-container")?.classList.add("hidden")
    }
  })

  function formatDate(date: Date) {
    const day = date.getDate();
    const month = new Intl.DateTimeFormat('en-AU', { month: 'long', timeZone: 'Australia/Sydney' }).format(date);
    const suffix = (day % 10 === 1 && day !== 11) ? 'st' :
                   (day % 10 === 2 && day !== 12) ? 'nd' :
                   (day % 10 === 3 && day !== 13) ? 'rd' : 'th';

    return `${month} ${day}${suffix}`;
  }
})